import { render, staticRenderFns } from "./departmentFileManagementAction.vue?vue&type=template&id=23ef9274&scoped=true"
import script from "./departmentFileManagementAction.vue?vue&type=script&lang=js"
export * from "./departmentFileManagementAction.vue?vue&type=script&lang=js"
import style0 from "./departmentFileManagementAction.vue?vue&type=style&index=0&id=23ef9274&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ef9274",
  null
  
)

export default component.exports